import { render, staticRenderFns } from "./MapConfig.vue?vue&type=template&id=874c3612&"
import script from "./MapConfig.vue?vue&type=script&lang=js&"
export * from "./MapConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports